import { useNavigate } from "react-router-dom";
import { DashboardShell } from "../components/dashboard/DashboardKit";
import { Home, FolderOpen, PlusCircle } from "lucide-react";

const engineerNav = [
  { icon: <Home className="w-5 h-5" />, label: "Dashboard",   path: "/engineer"          },
  { icon: <FolderOpen className="w-5 h-5" />, label: "My Projects", path: "/engineer/projects" },
  {
    icon: <PlusCircle className="w-5 h-5" />,
    label: "Add Project",
    path: "/engineer/add-project"
  }
];

const engineerStats = [
  { label: "Assigned", value: "04", className: "text-ap-violetLight" },
  { label: "Tasks",    value: "07", className: "text-ap-orange"      },
  { label: "Reports",  value: "12", className: "text-ap-red"         },
];

const MONTSERRAT = `@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');`;

function EngineerLayout({ children }) {
  const navigate = useNavigate();
  const userName = localStorage.getItem("name") || "Engineer";

  const userInitials = userName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <DashboardShell
      portal="Engineer Portal"
      roleLabel="ENGINEER"
      title="Engineer Workspace"
      subtitle="Manage your assigned projects, schedules and submitted reports"
      navItems={engineerNav}
      stats={engineerStats}
      user={{
        initials: userInitials,
        name:     userName,
        role:     "Engineer",
        onLogout: handleLogout,
      }}
  >
      <style>{MONTSERRAT + ` * { font-family: 'Montserrat', sans-serif !important; }`}</style>
      {children}
    </DashboardShell>
  );
}

export default EngineerLayout;